import moment from 'moment';
import { createUrl } from '_clean-code/utils/urlHelper';
import apiClient from '../../api/index';
import { IStopsService, StopItemType } from './contracts/stops.service';

const transformStopsResponse = (data: any[]) => {
  function formatHoursWithPlusOneFormat(shiftStartTime, targetDateMoment) {
    const toReplaceWhenSameDay = moment(shiftStartTime).format('YYYY-MM-DD ');
    if (
      targetDateMoment
        .format('YYYY-MM-DD HH:mm')
        .indexOf(toReplaceWhenSameDay) > -1
    ) {
      return targetDateMoment.format('HH:mm');
    }
    return targetDateMoment.format('HH:mm (+1)');
  }

  return data.map((a) => {
    const shiftDayDate = moment(a.shiftStartTime)
      .startOf('day')
      .local(true)
      .toDate(); // because of ag grid
    return {
      ...a,
      stopStartTimeHHmm: formatHoursWithPlusOneFormat(
        a.shiftStartTime,
        moment(a.stopStartTime)
      ),
      stopEndTimeHHmm: a.stopEndTime
        ? formatHoursWithPlusOneFormat(a.shiftStartTime, moment(a.stopEndTime))
        : '',
      shiftDayDate,
      stopDurationMinutes: moment(a.stopEndTime).diff(
        moment(a.stopStartTime),
        'minute'
      )
    };
  });
};

const StopsService: IStopsService = {
  getStopsByShift: async (shiftId: number): Promise<StopItemType[]> => {
    const response = await apiClient.request(
      'GET',
      createUrl('/v2/stops').addQueryParam('shiftId', shiftId).toStringUrl()
    );

    const data = response.data as StopItemType[];
    return transformStopsResponse(data);
  }
};

export default StopsService;
